import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { IAuthStore, IAuthStoreProps } from '../types/store'

const INITIAL_STORE: IAuthStoreProps = {
  accessToken: null,
  refreshToken: null,
}

export const useAuthStore = create<IAuthStore>()(
  persist(
    set => {
      return {
        ...INITIAL_STORE,
        saveAuth: ({ accessToken, refreshToken }) => {
          set({
            accessToken,
            refreshToken,
          })
        },
        clear: () => {
          set(INITIAL_STORE)
        },
        clearAccessToken: () => {
          set(state => ({ ...state, accessToken: null }))
        },
      }
    },
    {
      name: 'token-storage',
    },
  ),
)
